module.exports = __webpack_public_path__ + "img/111.343c61f4.jpg";